import { httpCodes } from '@shared/constants/httpCodes'

import BaseHTTPError from './BaseHTTPError'

export default class UnauthorizedError<Data> extends BaseHTTPError<Data> {
  constructor(info: { message: string; action: string; data?: Data }) {
    super({
      name: UnauthorizedError.name,
      httpCode: httpCodes.UNAUTHORIZED,
      message: info.message,
      action: info.action,
      data: info?.data
    })
  }
}
